import { render } from "./CIS-Tabs-Tab.vue?vue&type=template&id=02202d8a&scoped=true"
import script from "./CIS-Tabs-Tab.vue?vue&type=script&lang=js"
export * from "./CIS-Tabs-Tab.vue?vue&type=script&lang=js"

import "./CIS-Tabs-Tab.vue?vue&type=style&index=0&id=02202d8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02202d8a"]])

export default __exports__